export default {
    title_list: 'Circle lists',
    title_page: 'Circle list',
    title_create_page: 'Create circle list',
    title_edit_page: 'Change circle list',

    filter: {
        labels: {

        }
    },

    table: {
        labels: {
            id: 'ID',
            user_id: 'Owner',
            name: 'Title',
            members: 'Count members',
        }
    },

    buttons: {

    },

    form: {
        user_id: 'Owner',
        name: 'Title'
    },
}
